<template>
  <div
    class="max-w-md bg-white dark:bg-stone-800 rounded-xl shadow-md overflow-hidden transform transition duration-300 hover:shadow-lg flex flex-col">
    <div class="px-6 pt-6 pb-2 flex-grow">
      <h3 class="text-2xl font-bold text-primary-600 dark:text-primary-400 mb-4">
        Popular Uses for Spin the Names
      </h3>
      <div class="text-stone-700 dark:text-stone-300">
        <p class="mb-3">
          Our random name selector wheel is the perfect solution for:
        </p>
        <ul class="space-y-2 mb-4 list-none">
          <li class="flex items-start">
            <span class="inline-block w-2 h-2 mt-2 mr-2 rounded-full bg-primary-500"></span>
            <span><strong>Teachers</strong> - Randomly select students for answers, activities, or classroom
              responsibilities</span>
          </li>
          <li class="flex items-start">
            <span class="inline-block w-2 h-2 mt-2 mr-2 rounded-full bg-primary-500"></span>
            <span><strong>Event Planners</strong> - Choose raffle winners and giveaway recipients with visual
              excitement</span>
          </li>
          <li class="flex items-start">
            <span class="inline-block w-2 h-2 mt-2 mr-2 rounded-full bg-primary-500"></span>
            <span><strong>Team Leaders</strong> - Assign tasks fairly or determine speaking order in meetings</span>
          </li>
          <li class="flex items-start">
            <span class="inline-block w-2 h-2 mt-2 mr-2 rounded-full bg-primary-500"></span>
            <span><strong>Parents</strong> - Select chores, decide family activities, or create fair rotation
              systems</span>
          </li>
          <li class="flex items-start">
            <span class="inline-block w-2 h-2 mt-2 mr-2 rounded-full bg-primary-500"></span>
            <span><strong>Content Creators</strong> - Pick contest winners from your audience with live suspense</span>
          </li>
          <li class="flex items-start">
            <span class="inline-block w-2 h-2 mt-2 mr-2 rounded-full bg-primary-500"></span>
            <span><strong>Decision Making</strong> - Break decision paralysis by letting the wheel choose your next
              task</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="h-1 bg-gradient-to-r from-primary-300 to-primary-500 flex-none"></div>
  </div>
</template>
